import r from "./ScalarDropdownDivider.vue2.js";
import { createElementBlock as o, openBlock as e } from "vue";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const c = { class: "-mx-0.75 my-0.75 h-border bg-border" };
function n(s, p, a, d, i, m) {
  return e(), o("div", c);
}
const u = /* @__PURE__ */ t(r, [["render", n]]);
export {
  u as default
};
